'use client';

import { c as _c } from "react/compiler-runtime";
import { Grid } from '@7f-ui/components/grid';
import { Modal } from '@7f-ui/components/modal/modal';
import { useToast } from '@7f-ui/components/toast/toast-provider';
import type { CartItemExperienceFragment } from '@data-access/lib/gql/cart/documents';
import type { NexperienceTimeslotFragment } from '@data-access/lib/gql/experience/documents';
import { useCartItem } from '@feat/feat-cart/item';
import { useExperienceFilterContext } from '../../erlebnisse/_components/app-experience-filter-provider';
import { AppExperienceOffersList } from '../../erlebnisse/_components/app-experience-offers-list';
type AppExperienceListModalContentProps = {
  item: CartItemExperienceFragment;
  onClose: VoidFunction;
};
export function AppExperienceListModalContent(t0) {
  const $ = _c(8);
  const {
    item,
    onClose
  } = t0;
  const toast = useToast();
  const {
    filter
  } = useExperienceFilterContext();
  const {
    updateExperience
  } = useCartItem();
  let t1;
  if ($[0] !== filter || $[1] !== item || $[2] !== onClose || $[3] !== toast || $[4] !== updateExperience) {
    t1 = timeslot => new Promise(resolve => {
      if (!filter.selectedOptions) {
        resolve();
        return;
      }
      updateExperience(item.id, {
        timeslotId: timeslot.id,
        experienceId: item.experience.id,
        selectedOptions: filter.selectedOptions
      }, {
        onSuccess: () => {
          toast({
            type: "success",
            message: "Deine Auswahl wurde angepasst"
          });
          onClose();
          resolve();
        }
      });
    });
    $[0] = filter;
    $[1] = item;
    $[2] = onClose;
    $[3] = toast;
    $[4] = updateExperience;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const updateCartItem = t1;
  let t2;
  if ($[6] !== updateCartItem) {
    t2 = <Modal.Content><Grid className="!px-0 overflow-hidden"><div className="col-span-6 flex flex-col overflow-hidden sm:col-span-12"><div className="flex max-h-full flex-col pt-4 sm:pt-0"><div className="mt-4 flex flex-1 flex-col overflow-hidden"><AppExperienceOffersList onSubmit={updateCartItem} mode="update" /></div></div></div></Grid></Modal.Content>;
    $[6] = updateCartItem;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}